import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const defaults = {
    phone: "+351 910 000 000",
    whatsapp: "351910000000",
    email: "ola@ohomemdaobra.pt",
    coverage_area: "Lisboa • Oeiras • Cascais e arredores",
    hours: "Seg–Sex 09:00–19:00 • Sáb 09:00–13:00",
    hero_headline: "Obras bem feitas. Sem complicações.",
    hero_subheadline: "Remodelações, gestão de obra e valorização de imóveis com acompanhamento próximo, soluções claras e atenção aos detalhes.",
    social_facebook: "",
    social_instagram: "",
};

const SettingsContext = createContext(defaults);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(defaults);

    useEffect(() => {
        api.get("/config").then((r) => setSettings({ ...defaults, ...r.data })).catch(() => {});
    }, []);

    const whatsappLink = useCallback(
        (msg = "Olá. Encontrei O Homem da Obra através do website e gostaria de pedir informações sobre um trabalho.") =>
            `https://wa.me/${(settings.whatsapp || "").replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`,
        [settings.whatsapp],
    );

    const value = useMemo(() => ({ settings, whatsappLink }), [settings, whatsappLink]);

    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
